import React, { useEffect, useState } from "react";
import Breadcrumb from "../components/common/Breadcrumb";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";
import ContactArea from "../components/Contact/ContactArea";
import ContactAreaTwo from "../components/Contact/ContactAreaTwo";
import ContactMap from "../components/Contact/ContactMap";
import SEO from "../components/seo";
import { useLanguage } from "../contexts/LanguageContext";

const Contact = ({
  CONTACT_PAGE_TITLE = "Contact",
  BREADCRUMB_TITLE = "Contact",
  BREADCRUMB_SUBTITLE = "Get In Touch",
  HOME = "Home",
}) => {
  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState({
    CONTACT_PAGE_TITLE, BREADCRUMB_TITLE, BREADCRUMB_SUBTITLE, HOME,
  });

  useEffect(() => {
    const translateAll = async () => {
      const keys = ['CONTACT_PAGE_TITLE', 'BREADCRUMB_TITLE', 'BREADCRUMB_SUBTITLE', 'HOME'];
      const originalTexts = { CONTACT_PAGE_TITLE, BREADCRUMB_TITLE, BREADCRUMB_SUBTITLE, HOME };
      const newTranslations = {};
      const translationPromises = keys.map(async (key) => {
        const translated = await translateContent(originalTexts[key]);
        return { key, translated };
      });
      const results = await Promise.all(translationPromises);
      results.forEach(({ key, translated }) => {
        newTranslations[key] = translated;
      });
      setTranslations(newTranslations);
    };
    translateAll();
  }, [currentLanguage, CONTACT_PAGE_TITLE, BREADCRUMB_TITLE, BREADCRUMB_SUBTITLE, HOME, translateContent]);

  return (
    <main>
      <SEO pageTitle={translations.CONTACT_PAGE_TITLE} />
      <Header />
      <Breadcrumb title={translations.BREADCRUMB_TITLE} subtitle={translations.BREADCRUMB_SUBTITLE} homeLabel={translations.HOME} />
      <ContactArea />
      <ContactAreaTwo />
      <ContactMap />
      <Footer />
    </main>
  );
};

export default Contact;